import React from "react"

import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Home from './pages/home';
import Confirm from './pages/confirm';

import {Global, css} from '@emotion/core';

function App() {
    return (
        <>
            <Global
                styles={css`
                    html {
                        font-size: 62.5%;
                        box-sizing: border-box;
                    }
                    *,
                    *:before,
                    *:after {
                        box-sizing: inherit;
                    }
                    body {
                        background-color: #1f517c;
                        font-size: 16px;
                        font-size: 1.6rem;
                        line-height: 1.5;
                        color: #191919;
                        font-family: 'Lato', sans-serif;
                    }
                    a {
                        color: #00aae4;
                        text-decoration: none;
                    }
                    a:hover {
                        text-decoration: underline;
                    }
                    h1 {
                        font-size: 4.5rem;
                        color: #fff;
                        font-weight: bold;
                        line-height: 1.2;
                    }
                    h2 {
                        font-size: 2rem;
                        color: #fff;
                        font-weight: normal;
                        line-height: 1.2;
                    }
                    h3 {
                        font-size: 2.4rem;
                        font-weight: bold;
                        line-height: 1.21;
                    }
                    h4 {
                        font-size: 1.6rem;
                        font-weight: normal;
                        line-height: 2.4;
                        color: #d42a2a;
                        margin: 0;
                    }
                    .boton {
                        border: none;
                        border-radius: 3px;
                        background-color: #1f517c;
                        width: 100%;
                        max-width: 300px;
                        height: 40px;
                        line-height: 40px;
                        font-size: 16px;
                        font-weight: normal;
                        font-size: 16px;
                        color: #fff;
                        margin: auto;
                        margin-top: 30px;
                        margin-bottom: 30px;
                        display: block;
                        cursor: pointer;
                    }
                    input {
                        border-radius: 3px;
                        border: solid 1px #7f7f7f;
                        width: 100%;
                        max-width: 300px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                    }
                    .boton:hover {
                        text-decoration: none;
                        background-color: #1f517c;
                    }
                    .sala {
                        border-radius: 3px;
                        background-color: #e8e2e2;
                        font-weight: bold;
                        max-width: 300px;
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        margin: auto;
                        margin-bottom: 20px;
                    }
                `}
            />

            <Router basename="/colacion/">
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/confirm/:dni" component={Confirm} />
                </Switch>
            </Router>
        </>
    );
}

export default App;
